import {
  AI_ACCOUNT_ROUTING_ENABLED_FLAG,
  AI_BROWSER_EXTERNAL_API_PROXY_ENABLED_FLAG,
  PROXY_OVERRIDE_BASIC_AUTHORIZATION_ENABLED_FLAG,
  AI_CAPACITY_LICENSE_ENABLED_FLAG,
  AI_CAPACITY_MARKUP_PERCENT_FLAG,
  type FeatureFlagDefinitionEntryInput,
  FEATURE_FLAG_TYPES,
  TENANT_MODEL_ROUTER_ENABLED_FLAG,
  TERRA_AI_GATEWAY_ENABLED_FLAG,
  TORCH_TENANT_LICENSE_FILTER_ENABLED_FLAG,
  EXTERNAL_NETWORK_ATTACK_SKIP_TARGET_REACHABILITY_CHECK_FLAG,
} from './feature-flags.constants';

export const SURFACE_FEATURE_FLAG_DEFINITIONS = [
  {
    name: AI_CAPACITY_LICENSE_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: AI_CAPACITY_MARKUP_PERCENT_FLAG,
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 0,
  },
  {
    name: 'EXTERNAL_NETWORK_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'EXTERNAL_NETWORK_CONNECTOR_SCAN_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'EXTERNAL_NETWORK_EXECUTION_SCHEDULER_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'EXTERNAL_NETWORK_AI_SIGNAL_GENERATION_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'EXTERNAL_NETWORK_WEB_APP_DRAFTS_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'EXTERNAL_NETWORK_SIGNAL_IMPORT_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'MAX_HOURLY_EXTERNAL_NETWORK_EXECUTIONS_PER_SURFACE',
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 5,
  },
  {
    name: 'EXTERNAL_NETWORK_RUNNER_MAX_PARALLEL_JOBS',
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 8,
  },
  {
    name: 'INTERNAL_NETWORK_PENTEST_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_VRI_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'INTERNAL_NETWORK_PENTEST_UX_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'INTERNAL_NETWORK_CLOUD_CRACKER_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_CVE_ENRICHMENT_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'INTERNAL_NETWORK_CVE_RETEST_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'INTERNAL_NETWORK_INSIGHTS_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'EXTERNAL_NETWORK_CVE_RETEST_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: EXTERNAL_NETWORK_ATTACK_SKIP_TARGET_REACHABILITY_CHECK_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_REMOTE_ATTACK_EXECUTION_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_BLOODHOUND_PROVISIONING_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_TUNNEL_MODE_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'HYBRID_CODE_SERVICE_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'INTERNAL_NETWORK_EXECUTION_SCHEDULER_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'MAX_HOURLY_INTERNAL_NETWORK_EXECUTIONS_PER_SURFACE',
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 5,
  },
  {
    name: 'ROTATING_PROXY_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'BRING_YOUR_OWN_AI_AZURE_FOUNDRY_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: TENANT_MODEL_ROUTER_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: AI_ACCOUNT_ROUTING_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: TERRA_AI_GATEWAY_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
    supportedTargetTypes: [],
  },
  {
    name: 'ADMIN_AUDIT_LOG_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'REMEDIATION_CODING_TOOLS_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'CODER_SOCKS5_PROXY_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'TWINGATE_BROWSER_SOCKS5_PROXY_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: AI_BROWSER_EXTERNAL_API_PROXY_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: PROXY_OVERRIDE_BASIC_AUTHORIZATION_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'TWINGATE_CONNECTORS_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'TWINGATE_MULTI_NETWORK_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'MAX_TWINGATE_NETWORKS',
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 1,
  },
  {
    name: 'TWINGATE_PROXY_RECONCILE_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'TAILSCALE_INTERNAL_APP_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'TAILSCALE_EGRESS_RECONCILE_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: 'TAILSCALE_CONNECTOR_REUSABLE_AUTH_KEY_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'MAX_TAILSCALE_NETWORKS',
    type: FEATURE_FLAG_TYPES.NUMBER,
    defaultValue: 1,
  },
  {
    name: 'INTERNAL_NETWORK_TUNNEL_BROKER_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: false,
  },
  {
    name: 'FINDING_ATTACK_PATH_GRAPH_ENABLED',
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
  },
  {
    name: TORCH_TENANT_LICENSE_FILTER_ENABLED_FLAG,
    type: FEATURE_FLAG_TYPES.BOOLEAN,
    defaultValue: true,
    supportedTargetTypes: ['tenant'] as const,
  },
] as const satisfies readonly FeatureFlagDefinitionEntryInput[];
